// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__YwuKn","spin":"loading_spin__+dI1g"};